var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShareScreenIconinline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6668 23.7499C26.241 23.7482 26.7912 23.5106 27.1972 23.089C27.6032 22.6673 27.8321 22.096 27.8337 21.4997V10.2501C27.8321 9.65388 27.6032 9.08252 27.1972 8.6609C26.7912 8.23928 26.241 8.00168 25.6668 8H8.33418C7.76 8.00168 7.2098 8.23928 6.80378 8.6609C6.39777 9.08252 6.16896 9.65388 6.16735 10.2501V21.4997C6.16721 21.7953 6.22317 22.0879 6.33201 22.361C6.44086 22.6341 6.60046 22.8822 6.8017 23.0911C7.00294 23.3001 7.24186 23.4658 7.50481 23.5789C7.76777 23.6919 8.04959 23.75 8.33418 23.7499H5.08342C4.79608 23.7499 4.52051 23.8684 4.31733 24.0794C4.11415 24.2904 4 24.5765 4 24.8749C4 25.1733 4.11415 25.4595 4.31733 25.6705C4.52051 25.8815 4.79608 26 5.08342 26H28.9166C29.2039 26 29.4795 25.8815 29.6827 25.6705C29.8859 25.4595 30 25.1733 30 24.8749C30 24.5765 29.8859 24.2904 29.6827 24.0794C29.4795 23.8684 29.2039 23.7499 28.9166 23.7499H25.6668ZM18.0855 19.7785V17.3143C15.0735 17.3143 13.0914 18.2682 11.586 20.3741C12.1922 17.3704 13.8722 14.3784 18.0855 13.7711V11.3747L21.9945 15.1542C22.0485 15.2069 22.0915 15.2706 22.1209 15.3412C22.1503 15.4118 22.1655 15.488 22.1655 15.5649C22.1655 15.6419 22.1503 15.718 22.1209 15.7886C22.0915 15.8593 22.0485 15.9229 21.9945 15.9756L18.0855 19.7785Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShareScreenIconinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share-screen-icon.inline.e912e95239fbe8173785a4a7edd1f32e.svg";